<!-- 上传文件 -->
<template>
  <div>
    <el-upload :action="baseUrl" :limit="limit" :before-upload="handleBeforeUpload" :on-exceed="handleExceed"
      :on-success="handleSuccess" :on-preview="handleViewFile" :on-remove="handleRemove" :file-list="fileList" :headers="headers"
      ref="upload">
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>

    <!-- 图片查看器 -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="viewerUrl" style="z-index: 9999;" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  props: {
    // 上传文件列表
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 最大上传数量
    limit: {
      type: Number,
      default: 3
    },
    // 上传文件最大size 单位：M
    size: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      baseUrl: '',
      fileList: [],
      showViewer: false,
      viewerUrl: [],
	  headers: {}
    }
  },
  components: {
    ElImageViewer
  },
  computed: {},
  watch: {
    // 监听上传成功 同步父组件
    fileList(v) {
      // 创建一个数据存放符合后端接口的数据
      const newList = []
      v.forEach((item) => {
        newList.push({
          fileType: item.fileType,
          fileUrl: item.url
        })
      })
      this.$emit('update:list', newList)
    }
  },
  mounted() {
    this.baseUrl = process.env.VUE_APP_SERVER_URL + '/clientApi/common/uploadFile';
	const TOKEN = sessionStorage.getItem('token');
	this.headers = {userToken: TOKEN};
    this.formatData(this.list)
  },
  methods: {
    // 格式化
    formatData(list) {
      list.forEach((item) => {
        this.fileList.push({
          name: item.fileUrl.split('/').pop(),
          url: item.fileUrl,
          fileType: item.fileType
        })
      })
    },

    // 上传之前
    handleBeforeUpload(file) {
      const isSize = file.size / 1024 / 1024 < this.size
      if (!isSize) {
        this.$message.error(`上传文件大小不能超过${this.size}M`)
      }
      return isSize
    },

    // 上传数量超过限制
    handleExceed() {
      this.$notify.error({
        title: '提示',
        message: `文件最大上传数量为${this.limit}个`
      })
    },

    // 上传成功
    handleSuccess(response) {
      const res = response.data[0]
      // 进行格式化符合elementUI上传组件file-list键名要求
      this.fileList.push({
        name: res.fileUrl.split('/').pop(),
        url: res.fileUrl,
        fileType: res.fileType
      })
    },

    // 移除已上传文件
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    // 点击已上传的文件
    handleViewFile(file) {
      const { fileType, url } = file
      if (fileType == '0') {
        this.viewerUrl = [url]
        this.showViewer = true
      } else {
        window.open(url)
      }
    },

    // 清空上传文件
    clearFiles() {
      this.fileList = []
      this.$refs.upload.clearFiles()
    },

    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
